import type { FC } from 'react';
import type { DataType } from '@/pages/+data';
import { Button, Flex, Icon, Typography } from '@ui';
import { useTranslation } from 'react-i18next';
import { useData } from 'vike-react/useData';
import { GenericPageSectionWrapper } from '@/components/GenericPageSectionWrapper/GenericPageSectionWrapper';
import { DISCORD_LINK } from '@/constants/constants';
import AirplanesSvg from './svg/airplanes.svg?react';
import RegionSvg from './svg/region.svg?react';
import styles from './TrainingSection.module.css';

export const TrainingSection: FC = () => {
    const { t } = useTranslation();
    const { publicEnableApply } = useData<DataType>();

    return (
        <GenericPageSectionWrapper size="xl" relative>
            <Flex justify="center">
                <Flex justify="space-between" align="center" className={styles.trainingSection}>
                    <RegionSvg className={styles.region} />
                    <Flex vertical gap={32} className={styles.text}>
                        <Typography.Heading level={2}>{t('Training_Title')}</Typography.Heading>
                        <Typography.Paragraph>{t('Training_Description')}</Typography.Paragraph>
                    </Flex>
                    <Button
                        href={publicEnableApply ? '/apply' : DISCORD_LINK}
                        icon={<Icon.Arrow />}
                        variant="secondary"
                        size="l"
                    >
                        {t('Training_Action')}
                    </Button>
                </Flex>
                <AirplanesSvg className={styles.airplanes} />
            </Flex>
        </GenericPageSectionWrapper>
    );
};
